module.exports = __webpack_public_path__ + "img/2020_11_12_float_grin_guy.9960a647.jpg";